import { clsx } from 'cn';

/** @internal */
export const Styles = Object.freeze({
  root: clsx('border-l border-base-100 bg-base-200 shadow-[-4px_4px_14px_rgba(0,0,0,0.25)]')
});
